import React from 'react'

function Ecommerce() {
  return (
    <div>
      {/* Hero Start */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 pt-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start">
              <h1 className="display-4 text-white mb-4 animated slideInRight">E-Commerce Website Development</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/index">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">E-Commerce Websites</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Build scalable, secure, and fully customizable online stores with Bluevipers Technology.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="E-Commerce Development" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>
      {/* Hero End */}

      {/* Feature Start */}
      <div className="container-fluid bg-dark feature pt-5">
        <div className="container pt-5">
          <div className="row g-5 justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Why Choose Bluevipers</div>
              <h1 className="text-white mb-4">Professional E-Commerce Solutions for Your Business</h1>
              <p className="text-light mb-5">
                Bluevipers Technology develops powerful e-commerce websites that help you sell online efficiently. 
                Our solutions include secure payment integration, responsive design, and easy product management.
              </p>
            </div>

            {/* Features */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="d-flex align-items-start bg-primary rounded p-4 h-100">
                <i className="fa fa-shopping-cart fa-3x text-white me-3" />
                <div>
                  <h5 className="text-white">User-Friendly Store</h5>
                  <p className="text-white-50 mb-0">Intuitive layout and easy navigation for your customers.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="d-flex align-items-start bg-success rounded p-4 h-100">
                <i className="fa fa-lock fa-3x text-white me-3" />
                <div>
                  <h5 className="text-white">Secure Payments</h5>
                  <p className="text-white-50 mb-0">Integrated payment gateways ensuring safe transactions.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="d-flex align-items-start bg-warning rounded p-4 h-100">
                <i className="fa fa-cogs fa-3x text-white me-3" />
                <div>
                  <h5 className="text-white">Custom Features</h5>
                  <p className="text-white-50 mb-0">Manage products, inventory, and orders easily.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* Feature End */}

      {/* Contact Start */}
      <div className="container-fluid bg-primary py-5">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8 wow fadeIn" data-wow-delay="0.3s">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Contact Us</div>
              <h1 className="text-white mb-4">Get in Touch with Bluevipers Technology</h1>
              <p className="text-white-50 mb-4">
                Call us at <strong>+91 8459432930</strong> or email at <strong>blueviperstechnology@gmail.com</strong>
              </p>
              <a href="/contact" className="btn btn-light rounded-pill px-4 py-2">Contact Now</a>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
    </div>
  )
}

export default Ecommerce
